import { atom } from "jotai";

import {
  ServiceReservationSpecifiedPeriodFlag,
  ServiceViewTermFlag,
  ServiceViewType,
  UserPlan,
  UserSpecialCommercialLaw,
} from "@/apis/clients";
import {
  ServiceFormAtom,
  ServiceFormErrors,
} from "@/states/service-form/types";

export const serviceFormAtom = atom<ServiceFormAtom>({
  isLoading: false,
  formId: undefined,
  pageId: undefined,
  formData: {
    service: {
      id: 0,
      type: "content-webinar",
      viewType: ServiceViewType.BUTTON,
      name: "",
      specialCommercialLaw: UserSpecialCommercialLaw.INVALID,
      options: [],
      reservation_specified_period_flag:
        ServiceReservationSpecifiedPeriodFlag.UNSPECIFIED,
      viewTermFlag: ServiceViewTermFlag.HIDE,
    },
    holdDates: [],
    customer: [],
  },
  inputs: {
    service: {
      detailIds: [],
      optionIds: [],
      serviceMenuId: undefined,
      serviceMenuOptionIds: [],
      serviceMenuReservationDateTime: undefined,
      quantity: {},
    },
    customer: {
      mailMagazine: false,
    },
  },
  errors: {
    service: {},
    customer: {},
  } as ServiceFormErrors,
  options: {
    industries: [],
  },
  payment: {},
  paymentMethod: {},
  clientSecret: undefined,
  plan: UserPlan.FREE,
  draft: {
    inputs: {
      service: {
        detailIds: [],
        optionIds: [],
        serviceMenuId: undefined,
        serviceMenuOptionIds: [],
        serviceMenuReservationDateTime: undefined,
        quantity: {},
      },
      customer: {
        mailMagazine: false,
      },
    },
    errors: {
      service: {},
      customer: {},
    } as ServiceFormErrors,
  },
  isAgreePolicy: false,
});
